import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginPage.css';

const LoginPage = () => {
  // Hooks
  const navigate = useNavigate();
  const location = useLocation();
  
  // State
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [projectDetails, setProjectDetails] = useState(null);
  const [projectLoading, setProjectLoading] = useState(true);

  // دریافت نامک پروژه از URL
  const urlParams = new URLSearchParams(location.search);
  const projectSlug = urlParams.get('project');

  // ✅ دریافت اطلاعات پروژه هنگام بارگذاری
  useEffect(() => {
    if (!projectSlug) {
      setProjectLoading(false);
      return;
    }
    const apiUrl = `https://sseo.afaq.lc/seo_architect_api/get_project_details.php?slug=${projectSlug}`;
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setProjectDetails(data.project);
        } else {
          setError('پروژه مورد نظر یافت نشد.');
        }
      })
      .catch(() => setError('خطا در ارتباط با سرور.'))
      .finally(() => setProjectLoading(false));
  }, [projectSlug]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const apiUrl = 'https://sseo.afaq.lc/seo_architect_api/login.php';

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, projectSlug }),
      });
      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('currentProjectSlug', projectSlug);
        navigate('/');
      } else {
        setError(data.message || 'خطا در ورود.');
      }
    } catch (err) {
      setError('خطا در برقراری ارتباط با سرور.');
    } finally {
      setLoading(false);
    }
  };
  
  if (projectLoading) {
    return <div className="login-container">در حال بارگذاری اطلاعات پروژه...</div>;
  }
  
  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        {/* ✅ نمایش لوگو و نام پروژه */}
        {projectDetails?.full_logo_path && (
            <img src={projectDetails.full_logo_path} alt={`لوگوی ${projectDetails.name}`} className="project-logo" />
        )}
        <h2>ورود به {projectDetails?.name || 'پروژه'}</h2>
        
        <div className="input-group">
          <label htmlFor="username">نام کاربری</label>
          <input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div className="input-group">
          <label htmlFor="password">رمز عبور</label>
          <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" disabled={loading}>{loading ? 'در حال ورود...' : 'ورود'}</button>
      </form>
    </div>
  );
};

export default LoginPage;